import React from 'react'
import Missing from "./Images/mortyrickmissing.png"
export default function Tester(props) {

   
    return (
        <div className="missing-character">
            <img src={Missing} />
            
        </div>
    )
}
